import { OfflinePaymentService } from "@/services";
import VueQrcode from "vue-qrcode";
const PaymentIDTable = () =>
  import(
    "@/components/OperationsPage/Deposit/Rial/PaymentID/paymentIDTable/index"
  );
export default {
  name: "payment-id",
  components: { PaymentIDTable, VueQrcode },
  props: [],
  data() {
    return {
      showModalHint: false,
      pageDetailsData: "",
      copyFlag: true,
      selectedGateway: "",
      gateways: []
    };
  },
  computed: {
    filteredGateways() {
      return this.gateways.filter(el => el.user_identifier === null);
    },
    filteredGeneratedGateways() {
      return this.gateways.filter(el => el.user_identifier !== null);
    }
  },
  mounted() {
    this.getGateways();
    this.pageDetails();
  },
  methods: {
    setAddressNotif() {
      if (this.copyFlag) {
        this.copyFlag = false;
        this.$toast.success(this.$t("operationsPage.copyAddress"));
      } else {
        setTimeout(() => {
          this.copyFlag = true;
        }, 1500);
      }
    },
    getGateways() {
      OfflinePaymentService.getOfflinePaymentWithIdentifierData()
        .then(response => {
          this.gateways = response.data.data;
        })
        .then(() => {
          this.gateways.map(el => {
            el.text = el.bank_name;
            el.value = el.id;
          });
        });
    },
    generateGateway(gateway_id) {
      OfflinePaymentService.generateOfflinePaymentWithIdentifierData(
        gateway_id
      ).then(() => {
        this.getGateways();
      });
    },
    pageDetails() {
      OfflinePaymentService.getOfflinePaymentWithIdentifierPageDetails().then(
        response => {
          this.pageDetailsData = response.data.data;
        }
      );
    },
    onCopy() {
      this.$toast.success(this.$t("operationsPage.copy"));
    },
  }
};
